import * as React from 'react';

import { InputError } from './InputError';
import { LabelContent } from './LabelContent';
import { baseInputClasses } from './Form';

interface Props
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  label: React.ReactNode;
  error?: string;
  hideLabel?: boolean;
}

export const TextArea = ({
  label,
  error,
  hideLabel = false,
  ...inputprops
}: Props) => {
  return (
    <div className="space-y-1">
      <label>
        <LabelContent hide={hideLabel}>{label}</LabelContent>

        <textarea
          {...inputprops}
          aria-invalid={error ? true : undefined}
          className={`${baseInputClasses(Boolean(error))} h-48`}
        />
      </label>

      {error && <InputError>{error}</InputError>}
    </div>
  );
};
